/*
*  Cart service
*
*  Provides User Shopping Cart service
* */


import {APIService} from "../core.es6";
import {uriCompile} from "../../utils.es6";


function cartDB() {

    let cartItems = [];

    return Object.freeze({
        getState,
        load,
        get
    });

    function exists(item) {
        return !!(cartItems.filter((cartItem) => {
            return cartItem.content.id === item.content.id && cartItem.category === item.category
        }).length)
    }

    function get(item) {
        if (exists(item))
            return cartItems.filter((cartItem) => {
                return cartItem.content.id === item.content.id && cartItem.category === item.category
            })[0]
    }

    function getState() {
        return [...cartItems]
    }

    function load(items) {
        cartItems = [ ...items.map(parseItem)];
    }

    function parseItem(item) {
        // fix item price for render
        item.price = item.price.toFixed(2).replace('.', ',');

        // fix photo item thumbnail
        if (item.category === 'photo')
            item.content.thumbnail = uriCompile(item.content.photo, 'WW_TSS');

        // fix item discount price (if applicable) for render
        if (item.discount === true)
            item.discount_price = item.discount_price.toFixed(2).replace('.', ',');

        return item
    }

}


export function cartService({container, namespace}) {

    // Cart HTTP API
    const http = APIService({
        version: 'v1.1',
        namespace: namespace,
    });

    // Cart DB
    const DB = cartDB();

    // Service State
    let total = 0;
    let price = 0;

    // Set initial state to container if provided
    if (container)
        container = Object.assign(container, getState());

    return Object.freeze({
        getCart,
        addItem,
        removeItem,
        getState,
    });

    function getState(isLoading=false) {
        return {
            total: total,
            price: getPrice(),
            items: DB.getState(),
            isLoading: isLoading
        }
    }

    function setState(resp) {
        // Load Cart items to DB
        DB.load(resp.items);
        total = resp.total;
        price = resp.price;

        // Update container if provided
        if (container)
            container.update(getState());

        // return current state
        return getState()

    }

    function getCart() {
        return http.list({}).then((resp) => {
            return setState(resp)
        }).fail(() => {
            return getState()
        })
    }

    function addItem({category, license, specs, content}) {
        return http.update({
            uri: 'add',
            payload: {
                items: [{
                    category: category,
                    license: license,
                    specs: specs,
                    content: content
                }]
            }
        }).then((resp) => {
            return setState(resp)
        }).fail(() => {
            return getState()
        })
    }

    function removeItem({category, license, specs, content}) {
        return http.update({
            uri: 'remove',
            payload: {
                items: [{
                    category: category,
                    license: license,
                    specs: specs,
                    content: content
                }]
            }
        }).then((resp) => {
            return setState(resp)
        }).fail(() => {
            return getState()
        })
    }

    function getPrice() {
        return price.toFixed(2).replace('.', ',')
    }
}


// WEBPACK FOOTER //
// ./avr_eshop/frontend/services/cart/service.es6